// src/lib/plLedgerApi.ts — 経営PL「元帳で深掘り」 の fetch と、 差異ランキング → ドリルの受け渡し
import { create } from "zustand";
import type {
  PlLedgerSummaryResponse, PlLedgerItemsResponse, PlLedgerLinesResponse,
} from "@shared/plLedger";

async function getJson<T>(url: string): Promise<T> {
  const res = await fetch(url, { credentials: "include" });
  if (res.status === 401) {
    if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
      window.location.assign("/login?next=" + encodeURIComponent(window.location.pathname));
    }
    throw new Error("Unauthorized");
  }
  if (!res.ok) throw new Error(`${res.status} ${res.statusText} — ${(await res.text()).slice(0, 200)}`);
  return res.json() as Promise<T>;
}

export const plLedgerApi = {
  summary: () => getJson<PlLedgerSummaryResponse>("/api/pl-ledger/summary"),
  items: (metrics: string[]) =>
    getJson<PlLedgerItemsResponse>(`/api/pl-ledger/items?metrics=${encodeURIComponent(metrics.join(","))}`),
  lines: (q: { metric: string; months: string[]; code?: string; vendor?: string; item?: string }) => {
    const p = new URLSearchParams({ metric: q.metric, months: q.months.join(",") });
    if (q.code != null) p.set("code", q.code);
    if (q.vendor != null) p.set("vendor", q.vendor);
    if (q.item != null) p.set("item", q.item);
    return getJson<PlLedgerLinesResponse>(`/api/pl-ledger/lines?${p}`);
  },
};

/** 差異ランキングの行クリック → 元帳ドリルの対象を渡す (seq で同じ科目の再クリックも拾う) */
export const usePlLedgerTarget = create<{
  group: string | null; metric: string | null; seq: number;
  open: (group: string, metric: string | null) => void;
}>((set) => ({
  group: null, metric: null, seq: 0,
  open: (group, metric) => set((s) => ({ group, metric, seq: s.seq + 1 })),
}));
